'use client'
import { useState } from 'react'
import { useFormFields, useForm } from '@payloadcms/ui'

export function CoordinatesPasteField() {
  const [raw, setRaw]       = useState('')
  const [status, setStatus] = useState<'idle' | 'ok' | 'err'>('idle')

  const dispatchFields       = useFormFields(([, dispatch]) => dispatch)
  const { setModified }      = useForm()

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const val = e.target.value
    setRaw(val)

    if (!val.trim()) { setStatus('idle'); return }

    // Accept "lat, lng" with any amount of whitespace, optional parentheses
    const clean = val.trim().replace(/[()]/g, '')
    const match = clean.match(/^(-?\d{1,3}(?:\.\d+)?)\s*,\s*(-?\d{1,3}(?:\.\d+)?)$/)
    if (match) {
      const lat = parseFloat(match[1])
      const lng = parseFloat(match[2])
      if (lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
        dispatchFields({ type: 'UPDATE', path: 'location.latitude',  value: lat })
        dispatchFields({ type: 'UPDATE', path: 'location.longitude', value: lng })
        setModified(true)
        setStatus('ok')
        return
      }
    }
    setStatus('err')
  }

  const borderColor = status === 'ok' ? '#4caf50' : status === 'err' ? '#e05f5f' : '#d0d0d0'

  return (
    <div style={{ marginBottom: 8 }}>
      <label style={{
        display: 'block', marginBottom: 6,
        fontSize: 11, fontWeight: 600,
        textTransform: 'uppercase', letterSpacing: '0.08em',
        color: '#9a9a9a',
      }}>
        Paste from Google Maps
      </label>
      <input
        type="text"
        value={raw}
        onChange={handleChange}
        placeholder="39.519688, 46.329385"
        style={{
          width: '100%', padding: '6px 10px',
          border: `1px solid ${borderColor}`, borderRadius: 4,
          fontSize: 13, fontFamily: 'monospace',
          background: '#fff', outline: 'none', boxSizing: 'border-box',
          transition: 'border-color 0.15s',
        }}
      />
      {status === 'ok' && (
        <div style={{ color: '#4caf50', fontSize: 11, marginTop: 4 }}>
          ✓ Latitude and longitude updated
        </div>
      )}
      {status === 'err' && (
        <div style={{ color: '#e05f5f', fontSize: 11, marginTop: 4 }}>
          ✗ Format not recognised — paste as: 39.5127, 46.3543
        </div>
      )}
    </div>
  )
}
